<template>
  <v-row no-gutters style="padding: 0 15px">
    <v-col v-if="is_fetching" cols="12">
      <v-skeleton-loader type="image"></v-skeleton-loader>
    </v-col>
    <v-col v-else-if="!is_report_available || !device_data" cols="12">
      <v-alert text prominent type="error" icon="mdi-cloud-alert">
        {{ $t("common.labels.noDataAvailable") }}
      </v-alert>
    </v-col>
    <v-col v-else>
      <div class="pb-4">
        <div>
          <div>
            <span style="font-size: 17px; color: #0581c6">Client: </span
            ><span style="font-size: 16px">{{ tenant }}</span>
          </div>
          <div>
            <span style="font-size: 17px; color: #0581c6">Report Date: </span
            ><span style="font-size: 16px">{{ report_date }}</span>
          </div>
          <div>
            <span style="font-size: 17px; color: #0581c6">Report Time: </span
            ><span style="font-size: 16px">{{ report_time }}</span>
          </div>
          <div>
            <span style="font-size: 17px; color: #0581c6">Recepients: </span
            ><span style="font-size: 16px">{{ final_recepient }}</span>
            <span v-if="recipients_number" style="font-size: 12px; color: #0581c6">
              ...+{{ recipients_number }} more</span
            >
          </div>
        </div>
        <div
          style="
            font-size: 24px;
            padding-left: 40px;
            padding-right: 40px;
            text-align: center;
            color: #0581c6;
            font-weight: bold;
          "
        >
          {{ $t("common.labels.reportAtGlance") }}:
          <div class="primaryGrey--text text-caption">({{ $t("common.times.time.last24Hours") }})</div>
        </div>
        <v-row class="pt-3">
          <v-col>
            <div style="font-size: 20px; background: #ffffff" class="font-weight-bold">
              {{ device_label }}
            </div>
          </v-col>
        </v-row>
        <v-row>
          <v-col
            cols="4"
            class="pt-0"
            v-for="(data, index) in page_content.device_details_h2"
            :key="data.label + index"
          >
            <div class="text-caption">
              {{ data.label }}
            </div>
            <div style="font-weight: bold">
              <span v-if="data.type == 'datetime'">{{ device_data[data.value] | date }}</span>
              <span v-else-if="data.type == 'date'">{{ $dateFormat(device_data[data.value]) }}</span>
              <span v-else>
                {{ device_data[data.value] || "-" }}
              </span>
              <!-- Update suffix as per user sleection of temperature unit -->
              <span v-if="data.suffix && device_data[data.value] && data.isTemperature">
                {{ data.suffix | temperatureSuffix }}
              </span>
              <span v-else-if="data.suffix && device_data[data.value]">{{ data.suffix }}</span>
              <!-- <span v-if="data.suffix && device_data[data.value]">{{ data.suffix }}</span> -->
            </div>
          </v-col>
          <v-col cols="4" class="pl-3 pt-0" v-for="(data, index) in page_content.latest_message_h2" :key="index">
            <v-row no-gutters>
              <v-col>
                <div class="width-50 text-caption">{{ data.label }}</div>
              </v-col>
            </v-row>
            <v-row no-gutters>
              <v-col>
                <div class="pr-4 text-h6" style="font-weight: bold">
                  <span v-for="(coldata, idx) in data.values" :key="idx"
                    ><span v-if="data.type == 'datetime'">{{ device_data[coldata] | date }}</span>
                    <span v-if="data.type == 'date'">{{ $dateFormat(device_data[coldata]) }}</span>
                    <span
                      v-if="
                        data.type == 'lookup' &&
                        (!(coldata in device_data) || (device_data[coldata] && device_data['Status'] != 3))
                      "
                      :class="`${data.colors[idx]}--text`"
                    >
                      <v-tooltip bottom>
                        <template v-slot:activator="{ on, attrs }">
                          <span v-bind="attrs" v-on="on">Unknown</span>
                        </template>
                        <span
                          ><b>Status:</b> {{ page_content.Status[device_data["Status"]] }}<br /><b>Operation:</b
                          >{{ page_content.Operation[device_data["Operation"]] }}</span
                        >
                      </v-tooltip>
                    </span>
                    <span v-else-if="data.type === 'temp'" :class="`${data.colors[idx]}--text`"
                      >{{ device_data[coldata] }}
                    </span>
                    <span v-else :class="`${data.colors[idx]}--text`">
                      {{ device_data[coldata] | round }}
                    </span>
                    <!-- Update suffix as per user sleection of temperature unit -->
                    <span class="text-caption" v-if="data.suffix && device_data[coldata] && data.isTemperature">
                      {{ data.suffix | temperatureSuffix }}
                    </span>
                    <span class="text-caption" v-else-if="data.suffix && device_data[coldata]">
                      {{ data.suffix }}
                    </span>
                    <span v-if="idx != data.values.length - 1"> /</span></span
                  ><span v-if="data.type == 'datetime'">{{ device_data[data.value] | date }}</span>
                  <span v-if="data.type == 'date'">{{ $dateFormat(device_data[data.value]) }}</span>
                  <span v-else>
                    {{ device_data[data.value] }}
                  </span>
                  <span class="text-caption font-weight-light" v-if="data.helptext">{{ data.helptext }}</span>
                  <span class="text-caption" v-if="data.suffix && device_data[data.value]">{{ data.suffix }}</span>
                </div>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12">
            <v-row no-gutters class="primaryDark--text">
              <v-col cols="12">
                <DataTableVT
                  :headers="page_content.messages_table_h2"
                  :items_list="message_list"
                  :no_search="no_search"
                  print="true"
                  no_pagination="true"
                  no_sort="true"
                />
              </v-col>
            </v-row>
            <v-row no-gutters v-for="(data, index) in page_content.h2_charts" :key="index">
              <v-col cols="12">
                <div class="primaryOutline--text text-subtitle-2 px-4">
                  {{ data.label }}
                </div>
              </v-col>
              <v-col cols="12">
                <LineChart
                  v-if="charts_data[index]"
                  :from_min="from_min"
                  :chartData="data"
                  :data="charts_data[index]"
                />
              </v-col>
            </v-row>
          </v-col>
        </v-row>
        <!--
        <v-row class="pa-3" v-if="map_data">
          <MapsVT
            height="40vh"
            :options="page_content.maps_config"
            :items="map_data"
            :center="get_center"
            :showRoute="!show_info_window"
            :hide_legends="show_info_window"
          />
        </v-row>
        -->
      </div>
    </v-col>
  </v-row>
</template>

<script>
import { content } from "../../config/scavenger_h2.js";
import DataTableVT from "../components/DataTableVT";
import LineChart from "../components/LineChart";
import { axios_get } from "../services/vt_service";
import { h2 } from "../services/powerdata";

const tenant_key = process.env["VUE_APP_TENANT_KEY"];

export default {
  name: "ScavengerH2DeviceReport",
  props: {
    deviceId: String,
  },
  components: {
    DataTableVT,
    LineChart,
  },
  data: function () {
    return {
      page_content: null,
      device_data: null,
      message_list: null,
      device_id: null,
      tenant: null,
      recepient: null,
      recipients_number: null,
      report_date: null,
      report_time: null,
      snackbar: false,
      dialog: false,
      from_min: true,
      no_search: true,
      show_info_window: true,
      is_fetching: true,
      is_report_available: false,
    };
  },
  mounted() {
    this.page_content = content;
    let id = this.$route.params.deviceId || this.deviceId;
    this.device_id = id;

    var d = new Date();
    this.tenant = this.$auth.user[tenant_key]["tenant"];
    this.recepient = this.$auth.user.email;
    this.report_date = this.$formatDate(d);
    this.report_time = d.getHours() + ":" + (d.getMinutes() < 10 ? "0" : "") + d.getMinutes() + ":" + d.getSeconds();

    this.getAssetDetails(id);
    this.getMessages();
  },
  methods: {
    async getAssetDetails(id) {
      let response = await axios_get(h2.get_scv_h2_asset, { id });
      //Convert OilTemp value to user selected unit
      response[0].OilTemp = this.$options.filters.toUserSelectedTempMetric(response[0].OilTemp);
      this.device_data = response[0];
    },
    async getMessages() {
      let response = await axios_get(h2.get_scv_h2_mesg, { id: this.device_id, duration: 1 });
      //Convert OilTemp value to user selected unit
      response.forEach((e) => {
        e.OilTemp = this.$options.filters.toUserSelectedTempMetric(e.OilTemp);
      });
      this.message_list = response;
      this.is_fetching = false;
      this.is_report_available = this.message_list.length !== 0;
    },
  },
  computed: {
    device_label: function () {
      let label =
        this.device_data.SiteName && this.device_data.AssetID
          ? `${this.device_data.SiteName}/${this.device_data.AssetID}`
          : this.device_data.SiteName || this.device_data.AssetID
            ? `${this.device_data.SiteName}${this.device_data.AssetID}`
            : null;
      return label ? label : this.deviceId || this.$route.params.deviceId;
    },
    final_recepient: function () {
      if (this.$route.name == "Report_Snapshot") {
        if (this.recipients_list && this.recipients_list.length > 0) {
          let recepients = "";
          let total = this.recipients_list.length;
          let limit = total > 7 ? 7 : total;
          for (var i = 0; i < limit; i++) {
            recepients = recepients
              ? recepients + "; " + this.recipients_list[i]["RecipientEmail"]
              : this.recipients_list[i]["RecipientEmail"];
          }
          return recepients;
        }
        return this.recepient;
      }
      return this.recepient;
    },
    charts_data() {
      return this.message_list && this.message_list.length > 0
        ? [
            [
              {
                id: "hydrogen",
                label: this.$t("views.ScavengerH2Details.charts.h2Charts.h2LevelandOilTemperature.hydrogen"),
                suffix: "ppm",
                type: "line",
                values: this.message_list
                  .filter((e) => {
                    return !!e.H2ppmCrt;
                  })
                  .map((e) => {
                    return { key: new Date(e.Timestamp), value: e.H2ppmCrt };
                  }),
              },
              {
                id: "oil_temperature",
                label: this.$t("views.ScavengerH2Details.charts.h2Charts.h2LevelandOilTemperature.oilTemperature"),
                suffix: "°C",
                type: "line",
                values: this.message_list
                  .filter((e) => {
                    return !!e.OilTemp;
                  })
                  .map((e) => {
                    return { key: new Date(e.Timestamp), value: e.OilTemp };
                  }),
              },
            ],
          ]
        : null;
    },
    map_data: function () {
      return this.computed_location_details.CurrentLat ? [this.computed_location_details] : [];
    },
    computed_location_details() {
      let temp_obj = JSON.parse(JSON.stringify(this.device_data));
      return temp_obj;
    },
    get_center: function () {
      return this.map_data
        ? new window.google.maps.LatLng(
            this.computed_location_details.CurrentLat,
            this.computed_location_details.CurrentLng
          )
        : null;
    },
  },
};
</script>

<style lang="scss" scoped></style>
